/* Shared AJAX add-to-cart for Melo quick-add forms.
   Falls back to a normal form POST if fetch is unavailable.
   Errors are written into a live region so they are announced. */

/* window.meloCartAdded — call after ANY successful /cart/add.js.
   Pre-launch check (v59) found every Melo add button looking for drawer
   triggers this theme does not have ([data-cart-drawer-toggle], #cart-icon-bubble),
   so each add fell through to a full page load of /cart. This theme's drawer is
   <cart-drawer-component>: tell it the cart changed (it redraws its own lines,
   and the header icon reads itemCount), then open it. On /cart itself, or if
   the drawer is missing, go to the cart page as before. */
window.meloCartAdded = window.meloCartAdded || function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'melo-add', data: { source: 'melo-add', itemCount: cart.item_count } }
      }));
      var drawer = document.querySelector('cart-drawer-component');
      var onCart = /\/cart\/?$/.test(window.location.pathname);
      if (drawer && typeof drawer.showDialog === 'function' && !onCart) { drawer.showDialog(); }
      else { window.location.href = root + 'cart'; }
    });
};
(function () {
  function wire(form) {
    if (form.dataset.meloWired) return;
    form.dataset.meloWired = '1';

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var errEl = form.querySelector('[data-melo-error]');
      var idEl = form.querySelector('input[name="id"]');
      if (!idEl || !idEl.value) return;

      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      if (errEl) errEl.textContent = '';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idEl.value), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || 'Could not add that to your cart.');
          return window.meloCartAdded();
        })
        .catch(function (err) {
          if (errEl) errEl.textContent = err.message + ' Try again, or open your cart.';
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-melo-quickform]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-wire after theme-editor section reloads
  document.addEventListener('shopify:section:load', init);
})();
